var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout-main bg-gray-200"},[_c('the-navbar'),_c('div',{staticClass:"router-wrapper"},[_c('router-view')],1),(!_vm.isPro)?_c('the-footer'):_vm._e(),(!_vm.isPro)?_c('biew-badge'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }